import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Text } from 'rebass/styled-components'

import { Tooltip } from '../../Overlays/Tooltip'
import { ChevronIcon } from '../../Icon'
import styles from './NavToggle.module.css'

export interface NavToggleProps {
  navExpanded: boolean
  setNavExpanded: React.Dispatch<React.SetStateAction<boolean>>
}
export const NavToggle = ({ navExpanded, setNavExpanded }: NavToggleProps): JSX.Element | null => {
  useEffect(() => {
    // Toggle the menu when ⌘ + / or ctrl + / is pressed
    const down = (e: KeyboardEvent) => {
      if (e.key === '/' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setNavExpanded((navExpanded: boolean) => !navExpanded)
      }
    }
    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [])

  const TooltipContent = () => (
    <Box>
      <FormattedMessage id={`navigation.secondary.toggle.${navExpanded ? 'collapse' : 'expand'}`} />
      <Text sx={{ color: 'grey300' }}>
        <FormattedMessage
          id={`navigation.secondary.toggle.shortcut.${
            typeof navigator !== 'undefined' && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ? 'apple' : 'default'
          }`}
        />
      </Text>
    </Box>
  )

  return (
    <Tooltip content={<TooltipContent />}>
      <button
        data-name="NavToggle"
        onClick={() => setNavExpanded(navExpanded => !navExpanded)}
        aria-label="Toggle navigation"
        aria-expanded={navExpanded}
        className={`${styles.navToggle} ${navExpanded ? styles.expanded : ''}`}
      >
        <ChevronIcon rotate={navExpanded ? '90deg' : '-90deg'} color="blue100" width={12} height={7} />
      </button>
    </Tooltip>
  )
}
